import styled from 'styled-components'

export const LinkToPropertyMapBase = styled.span`
  cursor: pointer;
  text-decoration: none;
  color: ${props => props.theme.colors.grey2};

  &:hover {
    color: ${props => props.theme.colors.grey3};

    img {
      opacity: 0.8;
    }
  }
`
